import { __getStatus, __setStatus } from "../../../_clearance/utils/utils";
import store from "redux/Store";

export const localRefreshTrackingTo = (obj, date, uid) => {
  const {
    inbox: { allUsers },
  } = store.getState();
  obj.createdBy = obj.updatedBy = uid;
  obj.createdByName = (
    allUsers.find((v) => v.userId === uid) || { name: "Not found" }
  ).name;
  obj.createdAt = date;
};

export const localRefreshTrackingMeta = (
  obj,
  isNew = false,
  additional = null,
  noImage = false,
) => {
  const {
    user,
    user: { id: userid },
  } = store.getState();

  const { firstName, lastName, imageUrl } = user.credentials.orgID
    ? user.credentials.orgs.find((v) => v.id === user.credentials.orgID)
    : {};

  if (additional) obj = { ...obj, ...additional };

  if (isNew) {
    obj.createdBy = userid;
    obj.createdByName = firstName + " " + lastName;
    if(!noImage) {
      obj.createdByImageUrl = imageUrl;
    }
    obj.createdAt = new Date().toISOString();
  }

  obj.updatedBy = userid;
  obj.updatedByName = firstName + " " + lastName;
  if(!noImage) { 
    obj.updatedByImageUrl = imageUrl;
  }
  obj.updatedAt = new Date().toISOString();

  return obj;
};

export const __updateCfStatus = (cf) => {
  let cfstatus = "completed";
  if (cf.tracks.length === 0) {
    cfstatus = "inprogress";
  } else {
    cf.tracks.forEach((id) => {
      let st = __getStatus(cf, id);
      if (!st || st.unconfirmed) cfstatus = "inprogress";
    });
  }

  __setStatus(cf, cfstatus, null, "", true, 0);
  return __getStatus(cf);
};
